<template>
  <div class="thought-input-box">
    <StatusRedirect
      status="AFTER_TEST"
      @rewrite="(status) => checkApplicantStatus(status)"
    />
    <div v-if="applicantStatus === 'AFTER_TEST'">
      <p>これでコーディング試験は完了です。お疲れさまでした。</p>
      <p>工夫した点やうまくいかなかった点などを書いてください。</p>
      <b-form-textarea
        id="thought-input"
        v-model="thought"
        placeholder="感想を記入してください"
        rows="10"
        max-rows="10"
      />
      <p><span :class="switchActive()">{{ thought.length }}</span> / 1000</p>
      <b-button
        class="w-100"
        :variant="isActiveEndButton ? 'primary' : 'secondary'"
        :disabled="!isActiveEndButton"
        @click="callUpdateApplicantStatusAndRedirect()"
      >
        終了
      </b-button>
    </div>
  </div>
</template>

<script>
import StatusRedirect from '@/main/frontend/components/StatusRedirect.vue';
import {updateApplicantStatusAndRedirect} from '@/main/frontend/repository/exam/common.ts';

export default {
  components: {
    StatusRedirect,
  },
  data() {
    return {
      thought: '',
      isActiveEndButton: false,
      applicantStatus: '',
    };
  },
  methods: {
    // 感想入力の文字数によって、文字カウントの色と終了ボタンの状態を変更する
    switchActive() {
      const length = this.thought.length;
      if (length > 1000) {
        this.isActiveEndButton = false;
        return 'red';
      }
      this.isActiveEndButton = true;
      return 'black';
    },
    checkApplicantStatus(status) {
      this.applicantStatus = status;
    },
    callUpdateApplicantStatusAndRedirect() {
      // サロゲート文字が含まれていないかをチェックする
      if (this.thought.length != Array.from(this.thought).length) {
        alert('入力内容に送信できない文字が含まれています');
        return;
      }
      const config = {
        headers: {'Content-Type': 'application/json; charset = utf-8'},
      };
      Promise.resolve()
        .then(() => this.$axios.post('/api/exam/thought', this.thought, config))
        .then(() => updateApplicantStatusAndRedirect('COMPLETED'))
        .catch((e) => {
          // TODO: postに失敗したときの処理
          console.log(e);
        });
    },
  },
};
</script>

<style>
.thought-input-box {
  left: 50%;
  position: fixed;
  text-align: center;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}
.red {
  color: #f00;
}
.black {
  color: #000;
}
.display-none {
  display: none;
}
</style>
